module.exports = __webpack_public_path__ + "img/img14.f9669e93.jpg";